<template>
  <div class="pc-university">
    <BreadCrumb :data="breadcrumb" :title="'News列表管理'" />
    <ModuleClassfication
      :title="titles"
      class="pc-Article-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <MagazineArticleTable />
  </div>
</template>
<script>
// 功能模块
import BreadCrumb from "../../componentSet/BreadCrumb";
import MagazineArticleTable from "./components/MagazineArticleTable";
import ModuleClassfication from "./components/ModuleClassfication";
import {
  getArticleTopics_Api,
  addArticleTopics_Api,
  updateArticleTopics_Api,
  deleteArticleTopics_Api,
} from "@/apis/magazine.api";
export default {
  components: {
    BreadCrumb,
    MagazineArticleTable,
    ModuleClassfication,
  },
  data() {
    return {
      titles: {
        module: "News",
        class: [{ name: "News分类", subTitles: [] }],
      },
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "New列表", link: "/admin/newsList" },
      ];
    },
  },
  mounted() {
    this.getArticleTopic();
  },
  methods: {
    updateTopic(topic, callback) {
      // if (topic.type == "News分类") {
      updateArticleTopics_Api({
        title: topic.title,
        classification_id: topic.id,
        status: topic.status,
      }).then(() => {
        callback();
        this.getArticleTopic();
      });
      // }
    },
    addTopic(topic, callback) {
      // if (topic.type == "News分类") {
      addArticleTopics_Api({
        title: topic.title,
        status: topic.status,
      }).then(() => {
        callback();
        this.getArticleTopic();
      });
      // }
    },
    deleteTopic(topic, callback) {
      console.log(topic);
      if (topic.type == "News分类") {
        deleteArticleTopics_Api({ classification_id: topic.id }).then(() => {
          callback();
          this.getArticleTopic();
        });
      }
    },
    getArticleTopic() {
      getArticleTopics_Api().then((res) => {
        this.$set(this.titles.class[0], "subTitles", res.data);
        console.log(this.titles);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/guihua/newsLatterList.vue